import { supabase } from './supabase';

/**
 * Conta quantos pins um usuário (FID) já mandou pros parques
 * Usa a função SQL count_pins_to_parks_by_fid
 * 
 * @param fid - Farcaster ID do usuário (número ou string)
 * @returns Número de pins enviados aos parques (0 se não houver compras)
 */
export async function countPinsToParksByFid(fid: number | string): Promise<number> {
  try {
    const fidNum = typeof fid === 'string' ? parseInt(fid, 10) : fid;
    
    const { data, error } = await supabase.rpc('count_pins_to_parks_by_fid', {
      p_fid: fidNum
    });

    if (error) {
      throw new Error(`RPC Error: ${error.message || JSON.stringify(error)}`);
    }

    // Garantir que retornamos um número
    const result = typeof data === 'number' ? data : (data ? parseInt(String(data), 10) : 0);
    return isNaN(result) ? 0 : result;
  } catch (err) {
    throw err;
  }
}
